var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransactGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7,21.9c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM17.7,14.7c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,9.6c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0h0c1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM30,2.4c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4h0c-.6-.5-1.3-.8-2-.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3,34.2c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM5.3,27.1c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3,46.6c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM42.3,39.4c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7,34.2c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM54.7,27.1c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30,58.9c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM30,51.8c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30,36c-1.6,0-3.1-.6-4.3-1.8-2.4-2.4-2.4-6.3,0-8.6s6.3-2.4,8.6,0c2.4,2.4,2.4,6.3,0,8.6-1.2,1.2-2.8,1.8-4.3,1.8ZM30,25.3c-1.2,0-2.4.4-3.3,1.3-1.8,1.8-1.8,4.7,0,6.5,1.8,1.8,4.7,1.8,6.5,0,1.8-1.8,1.8-4.7,0-6.5-.9-.9-2.1-1.3-3.3-1.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3,21.9c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM42.3,14.7c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7,46.6c-1.1,0-2.2-.4-3.1-1.3-1.7-1.7-1.7-4.4,0-6.1,1.7-1.7,4.4-1.7,6.1,0,1.7,1.7,1.7,4.4,0,6.1-.8.8-2,1.3-3.1,1.3ZM17.7,39.4c-.7,0-1.4.3-2,.8-1.1,1.1-1.1,2.9,0,4,1.1,1.1,2.9,1.1,4,0,1.1-1.1,1.1-2.9,0-4-.6-.5-1.3-.8-2-.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 8.8,
    width: 1.5,
    height: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    y: 29.2,
    width: 15.8,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 35.3,
    width: 1.5,
    height: 15.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3,
    y: 29.2,
    width: 15.8,
    height: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 37.2,
    width: 5,
    height: 1.5,
    transform: "translate(-20.4 26.6) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 21.1,
    width: 5,
    height: 1.5,
    transform: "translate(-4.3 33.3) rotate(-45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 35.5,
    width: 1.5,
    height: 5,
    transform: "translate(-15.7 38) rotate(-45)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 19.4,
    width: 1.5,
    height: 5,
    transform: "translate(-9 21.9) rotate(-45)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactGraph);
export default __webpack_public_path__ + "static/media/icon-transact-graph.ecbd98b51aacd097a7d6672dd7a488e5.svg";
export { ForwardRef as ReactComponent };